import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";

import CustomNavbar from "../../components/common/CustomNavbar";
import PageLayout from "../../components/layouts/PageLayout";

import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { addCompany } from "../../features/developer/DeveoperServices";

export default function RegisterCompany() {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const [name, setName] = useState("");
    const [website, setWebsite] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!name.trim() || !website.trim()) {
            toast.error("Please fill all fields");
            return;
        }

        try {
            new URL(website.startsWith("http") ? website : `https://${website}`);
        } catch {
            toast.error("Please enter a valid website URL");
            return;
        }

        setSubmitting(true);

        try {
            await dispatch(
                addCompany({ name: name.trim(), website: website.trim() })
            ).unwrap();

            toast.success("Company registered successfully!");
            // Navigate back to the list after success
            navigate("/admin/developer/company");
        } catch (err: any) {
            toast.error(
                typeof err === "string"
                    ? err
                    : err?.message || "Failed to add company"
            );
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <PageLayout
            customNavbar={
                <CustomNavbar>
                    <div className="flex gap-3 items-center w-max">
                        <IoArrowBack
                            className="text-2xl cursor-pointer hover:text-brand-main"
                            onClick={() => navigate("/admin/developer/company")}
                        />
                        <span className="font-bold text-lg uppercase">Register Company</span>
                    </div>
                </CustomNavbar>
            }
        >
            <div className="bg-white rounded-4xl p-7 flex flex-col gap-8">
                <div>
                    <h2 className="text-2xl font-bold text-gray-800">
                        Register Your Company
                    </h2>
                    <p className="text-sm text-gray-400 mt-1">
                        Enter your company details to continue. Review usually takes up to 12 hours.
                    </p>
                </div>

                <hr />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex flex-col gap-1.5">
                        <label className="text-sm font-medium text-gray-600">
                            Company Name
                        </label>
                        <input
                            type="text"
                            placeholder="Company name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="border rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100"
                        />
                    </div>

                    <div className="flex flex-col gap-1.5">
                        <label className="text-sm font-medium text-gray-600">
                            Website URL
                        </label>
                        <input
                            type="url"
                            placeholder="https://yourcompany.com"
                            value={website}
                            onChange={(e) => setWebsite(e.target.value)}
                            className="border rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100"
                        />
                    </div>
                </div>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={() => navigate("/admin/developer/company")}
                        className="px-6 py-2 border rounded-xl text-sm text-gray-600 hover:bg-gray-50"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={submitting}
                        className="px-6 py-2 bg-brand-blue-gradient text-white rounded-xl text-sm font-semibold disabled:opacity-60"
                    >
                        {submitting ? "Registering..." : "Register Company"}
                    </button>
                </div>
            </div>
        </PageLayout>
    );
}
